import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import { TABLE_ROW_HEIGHT } from '../table/constants/sizes';
import ScrollToTopButtonComponent from '../table/components/ScrollToTopButton';
import { jsx as _jsx } from "react/jsx-runtime";
const SCROLL_TO_TOP_THRESHOLD = 100 * TABLE_ROW_HEIGHT;
export function useScrollToTopButton(t0) {
  const $ = _c(10);
  const {
    scrollContainerElement,
    isEnabled,
    onScrollToTop
  } = t0;
  const [hasScrolledDown, setHasScrolledDown] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isEnabled || $[1] !== scrollContainerElement) {
    t1 = () => {
      if (!isEnabled || !scrollContainerElement) {
        return;
      }
      const el = scrollContainerElement;
      const handleScroll = () => {
        setHasScrolledDown(el.scrollTop > SCROLL_TO_TOP_THRESHOLD);
      };
      el.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => el.removeEventListener("scroll", handleScroll);
    };
    t2 = [scrollContainerElement, isEnabled];
    $[0] = isEnabled;
    $[1] = scrollContainerElement;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const showScrollToTop = isEnabled && onScrollToTop && hasScrolledDown;
  let t3;
  if ($[4] !== onScrollToTop || $[5] !== scrollContainerElement || $[6] !== showScrollToTop) {
    t3 = showScrollToTop ? /*#__PURE__*/_jsx(ScrollToTopButtonComponent, {
      visible: true,
      onClick: () => {
        scrollContainerElement === null || scrollContainerElement === void 0 || scrollContainerElement.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        onScrollToTop();
      }
    }) : null;
    $[4] = onScrollToTop;
    $[5] = scrollContainerElement;
    $[6] = showScrollToTop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const ScrollToTopButton = t3;
  let t4;
  if ($[8] !== ScrollToTopButton) {
    t4 = {
      ScrollToTopButton
    };
    $[8] = ScrollToTopButton;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}